<ng-container *transloco="let _t">

<div *ngIf="showChart" id="echarts"
    echarts [options]="options" [theme]="theme" class="canvas-holder">
</div>

</ng-container>